import { IConstatacaoRecomendacaoModel } from './constatacao-recomendacao.model';
import { IAgentePublicoACModel } from "./agente-publico-ac.model";
import { IArquivoItemModel } from "./item-solicitacao-tecnica.model";
import { MatTableDataSource } from "@angular/material/table";
export enum StatusMatriz {
  NaoIniciada = 1,
  EmElaboracao = 2,
  Finalizada = 3,
  Aprovada = 4,
  Rejeitada = 5
}

export enum StatusConstatacao {
  NaoIniciada = 1,
  EmElaboracao = 2,
  Finalizada = 3,
  Cancelada = 4
}

    export enum StatusManifestacao {
      NaoIniciada = 1,
      EmElaboracao = 2,
      Enviado = 3,
      ComSugestoesAcatadas = 4,
      ComSugestoesNaoAcatadas = 5,
      SemSugestoes = 6
    }


export interface IStatusModel {
  codigo: number;
  descricao: string;
}

export interface IUsuarioModel {
  id: number;
  nome: string;
  email?: string;
}

export interface IUnidadeGestoraModel {
  id: number;
  sigla: string;
  nome: string;
}

export interface IConstatacaoModel {
  id?: number;
  matrizId: number;
  numeracao: string; // C1, C2, etc
  descricao: string;
  situacaoEncontrada: string;
  riscoVinculado: string;
  criteriosInfringidos: string;
  evidencias: IEvidenciaModel[];
  causas: ICausaEfeitoModel[];
  efeitos: ICausaEfeitoModel[];
  recomendacoes: IRecomendacaoModel[];
  status: number;
  responsavel?: IUsuarioModel;
  dataFinalizacao?: Date;
  dataCancelamento?: Date;
  justificativaCancelamento?: string;
  responsavelCancelamento?: IUsuarioModel;
  historico?: IHistoricoModel[];
  nome: string;
  constatacaoRecomendacao: IConstatacaoRecomendacaoModel[];
  ativo: boolean;
}

export interface ICausaEfeitoModel {
  id?: number;
  constatacaoId?: number;
  numero: number;
  descricao: string;
  tipo: 'causa' | 'efeito';
}


export interface IMatrizConstatacaoModel {
  id?: number;
  osaExecucaoId: number;
  tipo: number;
  numeroOsa: string;
  unidadeGestora: IUnidadeGestoraModel;
  tipoUnidade: 'principal' | 'subsidiaria';
  status: number;
  constatacoes: IConstatacaoModel[];
  dataGeracao?: Date;
  usuarioGeracao?: IUsuarioModel;
  dataAprovacao?: Date;
  usuarioAprovacao?: IUsuarioModel;
  comentarioAprovacao?: string;
  avaliacaoAprovacao?: 'aprovada' | 'rejeitada';
  matrizesUgs?: IMatrizUgModel[]; // Para matriz consolidada
  historico?: IHistoricoModel[];
  itens: IOsaExecucaoMatrizConstatacaoItemModel[];
  responsavel: IAgentePublicoACModel;
  identificador?: string;
  isOsaPrincipal?: boolean;
  isExisteConsolidada?: boolean;
}

export interface ICriarMatrizConstatacaoModel {
  id: number;
  osaExecucaoId: number;
}

export interface IMatrizUgModel {
  id: number;
  matrizConsolidadaId: number;
  tipoUg: string;
  nomeUg: string;
  totalConstatacoes: number;
  constatacoesFinalizadas: number;
  matrizDefinitivaId: number;
}

export interface IManifestacaoAuditadoModel {
  id?: number;
  osaExecucaoId: number;
  numeroOsa: string;
  nome: string;
  prazoResposta: Date;
  nomeResponsavel: string;
  responsavelPreenchimento: string;
  cargoResponsavel: string;
  identificador?: string;
  descricaoEnvio: string;
  anexosEnviados: IArquivoItemModel[];
  descricaoManifestacao: string;
  anexosRecebidos: IArquivoItemModel[];
  status: number;
  dataEnvio?: Date;
  usuarioEnvio?: IUsuarioModel;
  dataAvaliacao?: Date;
  dataFinalizacao?: Date;
  usuarioAvaliacao?: IUsuarioModel;
  avaliacaoTipo?: 'com_sugestoes_acatadas' | 'com_sugestoes_nao_acatadas' | 'sem_sugestoes';
  comentarioAvaliacao?: string;
  historico?: IHistoricoModel[];
  responsavel: IAgentePublicoACModel;
}

export interface IArquivoManifestacaoModel {
  id?: number;
  manifestacaoId?: number;
  tipo: 'enviado' | 'recebido';
  nomeArquivo: string;
  tamanhoArquivo: number;
  tipoArquivo: string;
  caminhoArquivo: string;
  dataCadastro?: Date;
}

// ==================== HISTÓRICO ====================

export interface IHistoricoModel {
  id?: number;
  entidadeId: number;
  entidadeTipo: 'matriz' | 'constatacao' | 'manifestacao';
  acao: string;
  descricao: string;
  usuario: IUsuarioModel;
  data: Date;
  dadosAnteriores?: any;
  dadosNovos?: any;
}

// ==================== DTOs PARA API ====================

export interface IGerarMatrizPreliminarDto {
  osaExecucaoId: number;
}

export interface IAprovarMatrizPreliminarDto {
  id: number;
  statusAvaliacao: number;
  comentarioAvaliacao: string;
  responsavelIdAvaliacao: string;
}

export interface ISalvarConstatacaoDto {
  id?: number;
  matrizId: number;
  numeracao: string;
  descricao: string;
  situacaoEncontrada: string;
  riscoVinculado: string;
  criteriosInfringidos: string;
  evidencias: IEvidenciaModel[];
  causas: string[];
  efeitos: string[];
    recomendacoes: Array<{
    id?: number;
    titulo?: string;
    descricao: string;
    selecionada?: boolean;
  }>;
}

export interface IFinalizarConstatacaoDto {
  constatacaoId: number;
  usuarioId: number;
}

export interface ICancelarConstatacaoDto {
  constatacaoId: number;
  justificativaCancelamento: string;
  responsavelCancelamentoId: string;
}

export interface IAtivarConstatacaoDto {
  constatacaoId: number;
  usuarioId: string;
}

export interface ISalvarManifestacaoDto {
  id?: number;
  osaExecucaoMatrizConstatacaoId: number;
  prazoResposta: string | null;
  nome: string;
  nomeResponsavel: string;
  cargoResponsavel: string;
  descricaoEnvio: string;
  anexosEnviados: IArquivoItemModel[];
  descricaoManifestacao: string;
  anexosRecebidos: IArquivoItemModel[];
  responsavelPreenchimento: string;
}

export interface IEnviarManifestacaoDto {
  manifestacaoId: number;
  usuarioId: string;
}

export interface IAvaliarManifestacaoDto {
  manifestacaoAuditadoId: number;
  avaliacaoTipo: 'com_sugestoes_acatadas' | 'com_sugestoes_nao_acatadas' | 'sem_sugestoes';
  comentario: string;
  usuarioAvaliacaoId: string;
}

export interface IGerarMatrizConsolidadaDto {
  osaExecucaoId: number;
}

export interface IExcluirMatrizConsolidadaDto {
  matrizConsolidadaId: number;
}

// ==================== RESPONSE MODELS ====================

export interface IApiResponse<T> {
  sucesso: boolean;
  dados?: T;
  mensagem?: {
    descricao: string;
    tipo: 'sucesso' | 'aviso' | 'erro';
  };
  erros?: string[];
}

export interface IValidacaoProgramaTrabalhoResponse {
  podeGerar: boolean;
}

export interface IValidacaoMatrizesDefinitivasResponse {
  todasFinalizadas: boolean;
  ugSubsidiariasPendentes: boolean;
  mensagem?: string;
}

export interface IRecomendacaoModel {
  id?: number;          // se existir
  titulo?: string;
  descricao: string;
}


export interface IOsaExecucaoMatrizConstatacaoItemModel {
  id: number;
  osaExecucaoMatrizConstatacaoId: number;
  osaExecucaoProgramaTrabalhoQuestaoConstatacaoId: number;
  identificador?: string;
  descricaoConstatacao?: string;
  responsavelId?: string;
  responsavelPreenchimento?: string;
  dataHoraFinalizacao?: Date;
  situacaoEncontrada?: string;
  causa?: string;
  efeito?: string;
  status: number;
  riscosVinculados?: string;
  criteriosInfringidos?: string;
  evidencias?: any[];
  recomendacoes?: IRecomendacaoModel[];
  responsavel: IAgentePublicoACModel;
  evidenciasDetalhadas?: IEvidenciaModel[];
  recomendacoesVinculadas?: string[];
}

export interface IEvidenciaModel {
  tipo: number;
  texto: string;

  arquivoId?: number;
  papelTrabalhoId?: number;
  nomeArquivo?: string;
  nomePapel?: string;
}

export interface IMatrizDefinitivaConsolidadaResponse {
  id: number;
  matrizConsolidadaId: number;
  osaExecucaoId: number;
  status: number;
  tipo: number;
  secoes: IMatrizConsolidadaUgSecaoModel[];
}

export interface IMatrizConsolidadaUgSecaoModel {
  unidadeGestoraId: number;
  unidadeGestoraNome: string;          // ex: "UG X - SIGLA" ou só Nome
  matrizDefinitivaUgId: number;
  statusMatrizUg: number;
  numeroOsa: string;
  itensFinalizados: IOsaExecucaoMatrizConstatacaoItemModel[];
}


export interface IMatrizConsolidadaUgSecaoVM extends IMatrizConsolidadaUgSecaoModel {
  collapseId: string;
  headingId: string;
  dataSource: MatTableDataSource<IOsaExecucaoMatrizConstatacaoItemModel>;
  semDados: boolean;
}
